<style type="text/css" media="screen">


</style>
<template>
	<div>

		<v-row class="mb-5">
			<v-col cols="9" md="6">
				<v-text-field
				v-model="trip_serch_query"
				:placeholder="$lang.COLLECTION_SEARCH"
				outlined
				rounded
				dense
				append-icon="mdi-magnify"
				@keyup="getDispatchHistory"
				hide-details
				></v-text-field>
			</v-col>
			<!-- <v-col cols="9" md="2" class="pt-3">

				<v-btn  rounded depressed  outlined  class="download-svg-btn" width="85" @click="dialog.flag=true">
					<v-icon>mdi-filter</v-icon>
					{{$lang.FILTER}}
				</v-btn>
			</v-col> -->
		</v-row>

		<div>
			<v-data-table
			:headers="headers"
			:items="deposit_list"
			:hide-default-footer="true"
			:disable-sort="true"
			:items-per-page="$keys.PAGE_LENGTH"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			@click:row="gotoTripDetails"
			>
			<template v-slot:item.delivery_agent="{ item }">
				<p>{{item.agent_name}}</p>
				<!-- <p>{{$lang.MOBILE_PREFIX}}{{item.delivery_agent_number}}</p> -->
			</template>	
			<template v-slot:item.date="{ item }">
				<span  >{{item.created_date}},{{item.created_time}}</span>
			</template>	
			<template v-slot:item.status="{ item }">
				<span :class="'transaction_'+item.status.toLowerCase()">
					{{item.status}}
				</span>
			</template>	
			<template v-slot:item.action="{ item }">
				<v-btn small fab text @click="gotoTripDetails(item)">	
					<img src="@/assets/arrow-right.svg" alt="">	
				</v-btn>	
			</template>	
			<!--empty state  -->
			<template v-slot:no-data>
				<empty-list :message="$lang.EMPTY_TRIP"/>
			</template>	


		</v-data-table>

		<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
		@input="getDispatchHistory"></v-pagination>

		<!-- <shipment-list/> -->
		<trip-filter :dialog="dialog" :filter_data="filter_data" @filter="getDispatchHistory"/>


	</div>
</div>
</template>

<script type="text/javascript">
export default {
	components: {
		TripFilter:()=> import('../dispatch-shipment/child/TripFilter')
	},
	watch: {
		selected: {
			handler(newVal, oldVal){
				if(newVal != oldVal){
					this.getShipmentIdList()
				}
			},
			deep: true
		}
	},
	data () {
		return {
			total_page_count:1,
			page_number:1,
			table_loading:false,
			deposit_list:[],
			trip_serch_query:"",
			headers: [
			{ text: 'Transaction ID', align: 'start',value: 'transaction_id',},
			{ text: 'Delevery Agent', value: 'delivery_agent' },
			{ text: 'Total Packages', value: 'total_package' },
			{ text: 'Total Amount', value: 'total_amount' },
			{ text: 'Received By', value: 'received_by' },
			{ text: 'Date, Time', value: 'date' },
			{ text: 'Status', value: 'status' },
			{ text: '', value: 'action' },
			],
			dialog:{
				flag:false
			},
			filter_data:{
				agent_id_list:[],
				line_id_list:[],
				filter_date_from:"",
				filter_date_to:"",
			},
		}
	},
	created(){
		this.$store.dispatch('drawer/setActiveTab',"collection") 
		this.getDispatchHistory()
	},
	methods:{
		/* fetching shipment list */ 
		getDispatchHistory(){
			const self=this
			this.$store.dispatch('setPageLoader', true)
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				search_query:this.trip_serch_query,
				agent_id_list:JSON.stringify(this.filter_data.agent_id_list),
				line_id_list:JSON.stringify(this.filter_data.line_id_list),
				filter_date_from:this.filter_data.filter_date_from,
				filter_date_to:this.filter_data.filter_date_to,
			};
			self.table_loading=true

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					this.deposit_list=response.data.deposit_list
					this.total_page_count=response.data.total_page_count
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};
			self.request_GET( self,self.$urls.DEPOSIT_HISTORY,params,successHandler,null,null,finallyHandler)
		},
		gotoTripDetails(item){
			this.$router.push({name:'collection-details',params:{transaction_id:this.encript(item.transaction_id)}})
		}

	}
}


</script>